<style lang="scss">
  @import "@/assets/scss/vuexy/components/login.scss";
</style>
<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="image-container-background">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2 login-image-container">
              <img :src="getImg()" alt="login" class="mx-auto login-image">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg ">
              <div class="float-right">
                <i18n textColor="text-primary" :isShow="true"/>
              </div>
              <div class="p-8 login-tabs-container">
                <div class="spore-logo-container">
                  <img src="@/assets/images/logo/logo.png" alt="login" class="spore-login-logo">
                </div>
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">{{$t("WelcomeMessage")}}</h4>
                  <p>{{$t("InputDataMessage")}}</p>
                </div>

                <div>
                  <vs-input
                  name="email"
                  icon-no-border
                  icon="icon icon-user"
                  icon-pack="feather"
                  :label-placeholder="$t('EmailLabel')"
                  v-model="email"
                  class="w-full" v-on:keyup.13="getLogin"/>

                  <vs-input
                  type="password"
                  name="password"
                  icon-no-border
                  icon="icon icon-lock"
                  icon-pack="feather"
                  :label-placeholder="$t('PasswordLabel')"
                  v-model="password"
                  class="w-full mt-6" v-on:keyup.13="getLogin"/>
                  <span class="text-danger text-sm" v-show="error">{{$t("Messages.MissingParams")}}</span>
                  <div class="flex flex-wrap justify-between my-5" >
                    <div class="float-right">
                      <router-link class="forgotten-password-link" to="/forgot-password">{{$t("ForgotPassword")}}</router-link>
                    </div>
                  </div>
                  <vs-button class="float-right login-button" style="margin-bottom: 50px;"  v-on:click="getLogin()">{{$t("Enter")}}</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import {request} from '@/request.js'
import {setToken} from '@/sessionStorage.js'
import i18n from '@/layouts/components/vertical-nav-menu/I18n.vue'

export default {
  components: {
    i18n
  },
  props:{
    urlLogin: String,
    redirectPath: String,
    img: String
  },
  data () {
    return {
      email: '',
      password: '',
      error: false
    }
  },
  methods: {
    async getLogin () {
      if (this.email && this.password) {
        this.$vs.loading()
        this.error = false

        const params = {
          url: this.urlLogin,
          method: 'POST',
          validate: false,
          params:{
            email: this.email,
            password: btoa(this.password)
          }
        }
        await request(params).then(response => {
          this.$session.set('email', btoa(this.email))
          this.$session.set('pass', btoa(this.password))
          setToken(response.data.data)
          /*this.$session.set('displayName',response.data.data.first_name + ' ' + response.data.data.last_name)
          this.$session.set('avatar',response.data.data.avatar)
          this.$session.set('uid',response.data.data.uid)
          this.$session.set('userRole',response.data.data.type)
          this.$store.commit('UPDATE_USER_INFO', {
            displayName: response.data.data.first_name + ' ' + response.data.data.last_name,
            uid: response.data.data.uid,
            avatar: response.data.data.avatar,
            userRole: response.data.data.type,
            token: response.data.data.token
          });*/
          const userDefaults = {
            uid         : 0,          
            displayName : 'Usuario General', 
            avatar      : '/9j/4AAQSkZJRgABAQEAYABgAAD//gA7Q1JFQVRPUjogZ2QtanBlZyB2MS4wICh1c2luZyBJSkcgSlBFRyB2NjIpLCBxdWFsaXR5ID0gOTAK/9sAQwADAgIDAgIDAwMDBAMDBAUIBQUEBAUKBwcGCAwKDAwLCgsLDQ4SEA0OEQ4LCxAWEBETFBUVFQwPFxgWFBgSFBUU/9sAQwEDBAQFBAUJBQUJFA0LDRQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQU/8AAEQgAMgAyAwEiAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/aAAwDAQACEQMRAD8A+7aKKtaZYPqd9FbR8FzyfQdzQBXVWdgqqWY9ABmlkhkhOJEZD6MMV6tpmkW2kwCO3jC8cufvN9TVi5tYbyIxzRrLGeqsMigDx6itnxPoY0S+AjybeUbo89vUf59axqACiiigArovArquu4bq0TBfrwf5A1ztS21zJZ3Ec0TbZEO5TQB7DRWBpXjGxvol8+RbWb+JZDhfwPSrN74p02yjLG6SZuyQncT+VAGP8Q3T7NZp/HvYj6Y5/pXD1f1rV5davWnkG1QNqIOiiqFABRRRQAV12geDrbULSO5mujKrDOyLjB9CTXI1e0rWbrR5i9u+AfvI3Kt9RQB6HB4X0u3AC2cbe75b+dPk8OaZKCGsYR/urt/lWLafEC2dQLm3kjfuY8MP6VLP4+sUU+XDNK3YYCj880AM1LwLZGJ5IJmtdoz8x3IPz5/WuFkUJIyhg4BIDL0PvWtrXii71kGNsQ2//PJD1+p71j0AFFFFABRRRQAUUUUAFFFFABRRRQB//9k=',
            status      : 'online',
            userRole    : 'admin',
            token       : response.data.data
          }
          this.$session.set('displayName', userDefaults.displayName)
          this.$store.commit('UPDATE_USER_INFO', userDefaults)
          window.location.href = this.redirectPath
        }).finally(() => {
          this.$vs.loading.close()

          this.password = ''

          /*this.$vs.notify({
            title:'Error!',
            position:'top-center',
            time:8000,
            text:'Tus credenciales no son correctas. Favor de volver a intentar',
            color:'danger',
            icon:'warning'});*/
        })
      } else this.error = true
    },
    getImg () {
      const images = require.context('@/assets/images/pages/login/', false, /\.png$/)
      return images(`./${  this.img}`)
    }
  }
 
}
</script>